export default ['xsm', 'xsmt'];
